<div *ngIf="!loading">
  <page-header [title]="title" [subtitle]="subtitle"></page-header>

  <div class="actions-container">
    <!-- Desktop view -->
    <div class="button-layout">
      <div class="right-buttons">
        <app-primary-button
          title="Actions"
          [disabled]="loading"
          [icon]="'more_vert'"
          [mat-menu-trigger-for]="actionsMenu"
        ></app-primary-button>
      </div>
    </div>
  </div>

  <!-- Desktop Actions Menu -->
  <mat-menu #actionsMenu="matMenu" class="custom-menu">
    <button
      mat-menu-item
      [disabled]="loading"
      (click)="openGiveStampsFromCustomerPage()"
    >
      <span style="text-decoration: none; color: black; font-size: 15px">
        Give Stamps
      </span>
    </button>

    <button mat-menu-item [disabled]="loading" (click)="giveReward()">
      <span style="text-decoration: none; color: black; font-size: 15px">
        {{ constants.strings.giveReward }}
      </span>
    </button>

    <button
      mat-menu-item
      [disabled]="loading"
      (click)="openAdjustPointsDialog()"
    >
      <span style="text-decoration: none; color: black; font-size: 15px">
        Adjust Points
      </span>
    </button>
  </mat-menu>

  <div class="detail-container" id="left">
    <mat-tab-group
      mat-align-tabs="start"
      mat-stretch-tabs="false"
      disableRipple="true"
      [animationDuration]="0"
      (selectedTabChange)="tabChanged($event.index)"
      [(selectedIndex)]="selectedIndex"
    >
      <mat-tab label="Overview">
        <ng-template matTabContent>
          <div class="row">
            <div class="col-lg-6">
              <div style="margin-top: 20px">
                <div class="form-field-label-subtitle">
                  Name
                  <mat-icon
                    *ngIf="
                      !isUser(customer.user) &&
                      canManageCustomer &&
                      merchantActive
                    "
                    class="edit-icon"
                    (click)="editCustomerName()"
                    matTooltip="Edit name"
                    >edit</mat-icon
                  >
                </div>
                <div class="form-field-label-title">
                  {{
                    isUser(customer.user)
                      ? customer.user.name
                      : (customer.name ?? "-")
                  }}
                </div>
              </div>

              <div style="margin-top: 20px" *ngIf="customerEmail !== ''">
                <div class="form-field-label-subtitle">
                  Email
                  <mat-icon
                    *ngIf="
                      !isUser(customer.user) &&
                      canManageCustomer &&
                      merchantActive
                    "
                    class="edit-icon"
                    (click)="editCustomerEmail()"
                    matTooltip="Edit email"
                    >edit</mat-icon
                  >
                </div>
                <div class="form-field-label-title">
                  {{ customerEmail
                  }}<span
                    ><info-icon
                      *ngIf="isUser(customer.user) && !customer.user.email"
                      text="This customer has switched off email notifications"
                    ></info-icon
                  ></span>
                </div>
              </div>

              <div style="margin-top: 20px">
                <div class="form-field-label-subtitle">
                  DOB
                  <mat-icon
                    *ngIf="
                      !isUser(customer.user) &&
                      canManageCustomer &&
                      merchantActive
                    "
                    class="edit-icon"
                    (click)="editCustomerDob()"
                    matTooltip="Edit DOB"
                    >edit</mat-icon
                  >
                </div>
                <div class="form-field-label-title">
                  {{
                    isUser(customer.user)
                      ? customer.user.dob
                        ? (customer.user.dob | date: constants.shortDate)
                        : "-"
                      : customer.dob
                        ? (customer.dob | date: constants.shortDate)
                        : "-"
                  }}
                </div>
              </div>

              <div style="margin-top: 20px">
                <div class="form-field-label-subtitle">Customer since</div>
                <div class="form-field-label-title">
                  {{ customer.createdAt | date: constants.longDate }}
                </div>
              </div>

              <div style="margin-top: 20px">
                <div
                  class="form-field-label-subtitle"
                  style="display: flex; align-items: center"
                >
                  Notes<mat-icon class="note-icon" (click)="editNotes()"
                    >edit_note</mat-icon
                  >
                </div>
                <div class="form-field-label-title">
                  {{ customer.notes }}
                </div>
              </div>

              <div style="margin-top: 20px" *ngIf="isUser(customer.user)">
                <div class="form-field-label-subtitle">
                  Notification Settings
                </div>
                <div class="custom-slider">
                  <mat-slide-toggle
                    #pushToggle
                    [disabled]="toggleDisabled(false)"
                    [(ngModel)]="pushNotificationsEnabled"
                    (change)="toggleCustomerNotifications(false)"
                    ><span
                      class="section-subtitle"
                      style="text-wrap: wrap; color: black"
                    >
                      {{ "Push Notifications" }}</span
                    >
                  </mat-slide-toggle>
                </div>
                <div class="custom-slider" style="margin-top: 10px">
                  <mat-slide-toggle
                    #emailToggle
                    [disabled]="toggleDisabled(true)"
                    [(ngModel)]="emailNotificationsEnabled"
                    (change)="toggleCustomerNotifications(true)"
                    ><span
                      class="section-subtitle"
                      style="text-wrap: wrap; color: black"
                    >
                      {{ "Email" }}</span
                    >
                  </mat-slide-toggle>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div
                *ngIf="getPreferences('communication')"
                style="margin-top: 20px"
              >
                <div class="form-field-label-subtitle">
                  Communication Preferences
                </div>
                <div class="form-field-label-title">
                  {{ getPreferences("communication") }}
                </div>
              </div>

              <div *ngIf="getPreferences('dietary')" style="margin-top: 20px">
                <div class="form-field-label-subtitle">Dietary Preferences</div>
                <div class="form-field-label-title">
                  {{ getPreferences("dietary") }}
                </div>
              </div>

              <div *ngIf="getPreferences('interests')" style="margin-top: 20px">
                <div class="form-field-label-subtitle">Interests</div>
                <div class="form-field-label-title">
                  {{ getPreferences("interests") }}
                </div>
              </div>

              <div *ngIf="getPreferences('shopping')" style="margin-top: 20px">
                <div class="form-field-label-subtitle">
                  Shopping Preferences
                </div>
                <div class="form-field-label-title">
                  {{ getPreferences("shopping") }}
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="hasStampCards !== false" label="Stamps">
        <ng-template matTabContent>
          <div class="row">
            <div class="col-lg-6">
              <chart
                [type]="'stamp'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></chart>
            </div>
            <div class="col-lg-6">
              <hourly-chart
                [type]="'stamp'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></hourly-chart>
            </div>
          </div>

          <ngx-datatable
            #stampsTable
            class="material"
            [headerHeight]="45"
            [rows]="stampEvents"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No stamps to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="stampLength"
            [offset]="stampIndex"
            (page)="stampPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="stampSize"
          >
            <ngx-datatable-column name="Stamp Date" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longestDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Card" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/card', row?.card?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.card?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <img
                  *ngIf="constants.isShopify(row)"
                  src="../../../assets/shopify-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquare(row)"
                  src="../../../assets/square-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isZapier(row)"
                  src="../../../assets/zapier-logo-small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isMake(row)"
                  src="../../../assets/make.jpeg"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquarespace(row)"
                  src="../../../assets/squarespace_logo_small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <span
                  *ngIf="
                    row?.source?.user?.nanoid ||
                      (row?.source?.nfc && !row?.source?.nfc?.master);
                    else altSource
                  "
                >
                  <a
                    *ngIf="row?.source?.user?.nanoid"
                    [routerLink]="['/team-member', row.source?.user?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                  <a
                    *ngIf="row?.source?.nfc"
                    [routerLink]="['/nfc-events', row.source?.nfc?.ref]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                </span>

                <ng-template #altSource>
                  {{ constants.sourceString(row) }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Stamp #" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.stampNumber }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Reward" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <mat-icon
                  class="status-icon"
                  style="color: green"
                  *ngIf="row.hasReward"
                  >check_circle</mat-icon
                >
                <mat-icon
                  class="status-icon"
                  style="color: red"
                  *ngIf="!row.hasReward"
                  >cancel</mat-icon
                >
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Location"
              [resizeable]="false"
              *ngIf="isLocationNotString(stampEvents)"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/location', row.location?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.location?.name }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="stampLength > 0">
                  <span>{{ stampsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="stampIndex + 1"
                  [size]="pageSize"
                  [count]="stampLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="stampsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="hasPointsCards !== false" label="Points">
        <ng-template matTabContent>
          <div class="row">
            <div class="col-lg-6">
              <chart
                [type]="'point'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></chart>
            </div>
            <div class="col-lg-6">
              <hourly-chart
                [type]="'point'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></hourly-chart>
            </div>
          </div>

          <ngx-datatable
            #pointsTable
            class="material"
            [headerHeight]="45"
            [rows]="pointsEvents"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No points to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="pointsLength"
            [offset]="pointsIndex"
            (page)="pointsPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="pointsSize"
          >
            <ngx-datatable-column name="Date" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longestDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Card" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/card', row?.card?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.card?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <img
                  *ngIf="constants.isShopify(row)"
                  src="../../../assets/shopify-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquare(row)"
                  src="../../../assets/square-logo.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isZapier(row)"
                  src="../../../assets/zapier-logo-small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isMake(row)"
                  src="../../../assets/make.jpeg"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <img
                  *ngIf="constants.isSquarespace(row)"
                  src="../../../assets/squarespace_logo_small.png"
                  width="20"
                  height="20"
                  style="margin-right: 5px"
                />
                <span
                  *ngIf="
                    row?.source?.user?.nanoid ||
                      (row?.source?.nfc && !row?.source?.nfc?.master);
                    else altSource
                  "
                >
                  <a
                    *ngIf="row?.source?.user?.nanoid"
                    [routerLink]="['/team-member', row.source?.user?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                  <a
                    *ngIf="row?.source?.nfc"
                    [routerLink]="['/nfc-events', row.source?.nfc?.ref]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                </span>

                <ng-template #altSource>
                  {{ constants.sourceString(row) }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Points" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.points ?? "-" | number: "1.0-0" }}
              </ng-template>
            </ngx-datatable-column>

            <!-- <ngx-datatable-column name="Reward" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <mat-icon
                  class="status-icon"
                  style="color: green"
                  *ngIf="row.hasReward"
                  >check_circle</mat-icon
                >
                <mat-icon
                  class="status-icon"
                  style="color: red"
                  *ngIf="!row.hasReward"
                  >cancel</mat-icon
                >
              </ng-template>
            </ngx-datatable-column> -->

            <ngx-datatable-column
              name="Location"
              [resizeable]="false"
              *ngIf="isLocationNotString(pointsEvents)"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/location', row.location?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.location?.name }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="pointsLength > 0">
                  <span>{{ pointsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="pointsIndex + 1"
                  [size]="pointsSize"
                  [count]="pointsLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="pointsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </ng-template>
      </mat-tab>

      <mat-tab label="Redemptions">
        <ng-template matTabContent>
          <div class="row">
            <div class="col-lg-6">
              <chart
                [type]="'redemption'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></chart>
            </div>
            <div class="col-lg-6">
              <hourly-chart
                [type]="'redemption'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></hourly-chart>
            </div>
          </div>

          <ngx-datatable
            #redemptionsTable
            class="material"
            [headerHeight]="45"
            [rows]="redemptions"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No redemptions to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="redemptionLength"
            [offset]="redemptionIndex"
            (page)="redemptionPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="redemptionSize"
          >
            <ngx-datatable-column name="Redemption Date" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longestDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Reward" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/reward', row?.reward?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.reward?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <!-- <ngx-datatable-column name="Card/PN" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.card?.title ?? "Push Notification" }}
              </ng-template>
            </ngx-datatable-column> -->

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                  *ngIf="
                    row?.source?.user?.nanoid ||
                      (row?.source?.nfc && !row?.source?.nfc?.master);
                    else altSource
                  "
                >
                  <a
                    *ngIf="row?.source?.user?.nanoid"
                    [routerLink]="['/team-member', row.source?.user?.nanoid]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                  <a
                    *ngIf="row?.source?.nfc"
                    [routerLink]="['/nfc-events', row.source?.nfc?.ref]"
                    (click)="$event.stopPropagation()"
                  >
                    {{ constants.sourceString(row) }}
                  </a>
                </span>

                <ng-template #altSource>
                  {{ constants.sourceString(row) }}
                </ng-template>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column
              name="Location"
              [resizeable]="false"
              *ngIf="isLocationNotString(redemptions)"
            >
              <ng-template let-row="row" ngx-datatable-cell-template>
                <a
                  [routerLink]="['/location', row.location?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ row?.location?.name }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="redemptionLength > 0">
                  <span>{{ redemptionsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="redemptionIndex + 1"
                  [size]="pageSize"
                  [count]="redemptionLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="redemptionsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </ng-template>
      </mat-tab>

      <mat-tab label="Cards">
        <ng-template matTabContent>
          <ngx-datatable
            #cardsTable
            class="material"
            [headerHeight]="45"
            [rows]="userCards"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No loyalty cards to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="cardLength"
            [offset]="cardIndex"
            (page)="cardPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="cardSize"
          >
            <ngx-datatable-column name="Date Taken" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Card" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="!(row?.card[0] ?? row?.card)?.title">
                  {{ (row?.card[0] ?? row?.card)?.title ?? "" }}
                </div>

                <a
                  *ngIf="(row?.card[0] ?? row?.card)?.title"
                  [routerLink]="['/card', (row?.card[0] ?? row?.card)?.nanoid]"
                  (click)="$event.stopPropagation()"
                >
                  {{ (row?.card[0] ?? row?.card)?.title }}
                </a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Progress" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div style="display: flex">
                  <mat-progress-spinner
                    class="progress"
                    [color]="color"
                    [mode]="mode"
                    [value]="valueObtainedPercent(row)"
                    [diameter]="20"
                    *ngIf="
                      (row?.card[0] ?? row?.card)?.points?.maxPoints > 0 ||
                      (row?.card[0] ?? row?.card)?.cardType === 'stamp'
                    "
                  >
                  </mat-progress-spinner>
                  <span>
                    {{
                      valueObtained(row).includes("/")
                        ? valueObtained(row)
                        : (valueObtained(row) | number: "1.0-0")
                    }}
                  </span>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Type" [resizeable]="true">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ cardType(row) }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="# Resets" [resizeable]="false">
              <ng-template ngx-datatable-header-template>
                <div>
                  # Resets
                  <info-icon
                    text="The number of times this card has been re-used, a useful metric for environmental benefit and cost saving"
                  ></info-icon>
                </div>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.resets === 0 ? "-" : (row?.resets ?? "-") }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Actions" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div
                  class="actions-icon-container"
                  [matTooltip]="'More actions'"
                  [matTooltipShowDelay]="500"
                  [mat-menu-trigger-for]="cardMenu"
                  [matMenuTriggerData]="{ userCard: row }"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon>more_horiz</mat-icon>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="cardLength > 0">
                  <span>{{ cardsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="cardIndex + 1"
                  [size]="pageSize"
                  [count]="cardLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="cardsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </ng-template>
      </mat-tab>

      <mat-tab label="Rewards">
        <ng-template matTabContent>
          <div class="row">
            <div class="col-lg-6">
              <chart
                [type]="'reward'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></chart>
            </div>
            <div class="col-lg-6">
              <hourly-chart
                [type]="'reward'"
                [chartType]="chartType"
                [customer]="customer._id"
                [days]="days"
                (optionTapped)="days = $event"
              ></hourly-chart>
            </div>
          </div>

          <ngx-datatable
            #rewardsTable
            class="material"
            [headerHeight]="45"
            [rows]="userRewards"
            [scrollbarV]="false"
            [messages]="{ emptyMessage: 'No rewards to display' }"
            [scrollbarH]="true"
            [footerHeight]="50"
            [columnMode]="'force'"
            [rowHeight]="48"
            [externalPaging]="true"
            [count]="rewardLength"
            [offset]="rewardIndex"
            (page)="rewardPageEvent($event)"
            (scroll)="handleScroll()"
            [limit]="rewardSize"
          >
            <ngx-datatable-column name="Date Received" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.createdAt | date: constants.longDate }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Reward" [resizeable]="false">
              <ng-template ngx-datatable-header-template>
                <div style="display: flex; flex-direction: column">
                  <div>Reward</div>
                  <div style="font-size: 12px; opacity: 0.7">Hidden Text</div>
                </div>
              </ng-template>

              <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="!(row?.reward[0] ?? row?.reward)?.title">
                  {{ (row?.reward[0] ?? row?.reward)?.title ?? "" }}
                </div>

                <a
                  *ngIf="(row?.reward[0] ?? row?.reward)?.title"
                  [routerLink]="[
                    '/reward',
                    (row?.reward[0] ?? row?.reward)?.nanoid,
                  ]"
                  (click)="$event.stopPropagation()"
                >
                  {{ (row?.reward[0] ?? row?.reward)?.title }}
                </a>

                <div
                  *ngIf="row?.rewardObj?.hiddenText"
                  class="reward-hidden-text"
                  [title]="row?.rewardObj?.hiddenText"
                >
                  {{ row?.rewardObj?.hiddenText }}
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Source" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div style="display: flex; align-items: center; gap: 4px">
                  {{ constants.userRewardSource(row) }}

                  <info-icon
                    *ngIf="row?.gifted && row?.giftedByUser"
                    [text]="constants.getGifterTooltip(row)"
                  ></info-icon>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Expiry" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  row?.expiry
                    ? (row?.expiry | date: constants.longDate)
                    : "Never"
                }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Status" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div
                  id="status-chip"
                  [ngClass]="constants.statusChipClass(row)"
                >
                  {{ constants.statusChipLabel(row) }}
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Actions" [resizeable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div
                  *ngIf="!row.hasExpired && !row.hasRedeemed"
                  class="actions-icon-container"
                  [matTooltip]="'More actions'"
                  [matTooltipShowDelay]="500"
                  [mat-menu-trigger-for]="rewardMenu"
                  [matMenuTriggerData]="{ reward: row }"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon>more_horiz</mat-icon>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-offset="offset"
                let-isVisible="isVisible"
              >
                <div class="page-count" *ngIf="rewardLength > 0">
                  <span>{{ rewardsRange }}</span>
                </div>
                <datatable-pager
                  [pagerLeftArrowIcon]="'datatable-icon-left'"
                  [pagerRightArrowIcon]="'datatable-icon-right'"
                  [pagerPreviousIcon]="'datatable-icon-prev'"
                  [pagerNextIcon]="'datatable-icon-skip'"
                  [page]="rewardIndex + 1"
                  [size]="pageSize"
                  [count]="rewardLength"
                  [hidden]="!(rowCount / pageSize > 1)"
                  (change)="rewardsTable.onFooterPage($event)"
                >
                </datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </ng-template>
      </mat-tab>

      <mat-tab *ngIf="hasVouchers !== false" label="Vouchers">
        <ngx-datatable
          #vouchersTable
          class="material"
          [headerHeight]="45"
          [rows]="userVouchers"
          [scrollbarV]="false"
          [messages]="{ emptyMessage: 'No vouchers to display' }"
          [scrollbarH]="true"
          [footerHeight]="50"
          [columnMode]="'force'"
          [rowHeight]="48"
          [externalPaging]="true"
          [count]="vouchersLength"
          [offset]="vouchersPageIndex"
          (page)="voucherPageEvent($event)"
          (scroll)="handleScroll()"
          [limit]="vouchersPageSize"
          (activate)="rowTappedNGX($event)"
        >
          <ngx-datatable-column name="Date" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.createdAt | date: constants.longDate }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Voucher" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ (row?.voucher[0] ?? row?.voucher)?.displayAs }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Code" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.code }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Status" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div id="status-chip" [ngClass]="constants.statusChipClass(row)">
                {{ constants.statusChipLabel(row) }}
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Redeemable Value" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.value | currency: "GBP" }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Remaining" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                (row?.remainingValue ?? row?.value) == 0
                  ? "-"
                  : (row?.remainingValue ?? row?.value | currency: "GBP")
              }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Cost" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row?.cost | currency: "GBP" }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Discount" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="discount-container">
                <span *ngIf="!row?.discount">-</span>

                <div *ngIf="row?.discount">
                  <span class="absolute-discount">{{
                    row?.discount?.value | currency: "GBP"
                  }}</span>
                  <span class="percentage-discount" *ngIf="row?.value > 0">
                    ({{ row?.discount?.percent | number: "1.0-0" }}%)
                  </span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Expiry" [resizeable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{
                row?.expiry ? (row?.expiry | date: constants.longDate) : "Never"
              }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-footer>
            <ng-template
              ngx-datatable-footer-template
              let-rowCount="rowCount"
              let-pageSize="pageSize"
              let-offset="offset"
              let-isVisible="isVisible"
            >
              <div class="page-count" *ngIf="vouchersLength > 0">
                <span>{{ vouchersRange }}</span>
              </div>
              <datatable-pager
                [pagerLeftArrowIcon]="'datatable-icon-left'"
                [pagerRightArrowIcon]="'datatable-icon-right'"
                [pagerPreviousIcon]="'datatable-icon-prev'"
                [pagerNextIcon]="'datatable-icon-skip'"
                [page]="vouchersPageIndex + 1"
                [size]="pageSize"
                [count]="vouchersLength"
                [hidden]="!(rowCount / pageSize > 1)"
                (change)="vouchersTable.onFooterPage($event)"
              >
              </datatable-pager>
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<loader [loading]="loading || locationsLoading"></loader>
<loader [loading]="saving || paging || nextLoading"></loader>

<mat-menu #cardMenu="matMenu" class="custom-menu">
  <ng-template matMenuContent let-userCard="userCard">
    <div *ngFor="let item of cardMenuOptions; let i = index">
      <div
        *ngIf="
          !item.openEndedOnly ||
          (userCard?.card[0] ?? userCard?.card)?.cardType === 'openEndedPoint'
        "
        [matTooltip]="tooltip"
        [style.cursor]="'not-allowed'"
      >
        <button
          [disabled]="!canManageCustomer"
          class="menu-list-item"
          style="border-radius: 5px"
          (click)="onClick(item.title, userCard)"
          mat-menu-item
        >
          <mat-icon
            fontSet="material-icons-outlined"
            style="
              font-size: 16px;
              vertical-align: middle;
              display: flex;
              align-items: center;
              margin-right: 5px;
            "
            >{{ item.icon }}</mat-icon
          >
          <span class="menu-list-item-label">{{
            (userCard?.card[0] ?? userCard?.card)?.cardType === "stamp"
              ? item.title
              : item.pointsTitle
          }}</span>
        </button>
      </div>
    </div>
  </ng-template>
</mat-menu>

<mat-menu #rewardMenu="matMenu" class="custom-menu">
  <ng-template matMenuContent let-reward="reward">
    <div
      *ngIf="!reward?.hasRedeemed && !reward?.hasExpired"
      [matTooltip]="tooltip"
      [style.cursor]="canManageCustomer ? 'pointer' : 'not-allowed'"
    >
      <button
        [disabled]="!canManageCustomer"
        class="menu-list-item"
        style="border-radius: 5px"
        (click)="onClick(rewardMenuOptions[0].title, reward._id)"
        mat-menu-item
      >
        <mat-icon
          fontSet="material-icons-outlined"
          style="
            font-size: 16px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            margin-right: 5px;
          "
          >{{ rewardMenuOptions[0].icon }}</mat-icon
        >
        <span class="menu-list-item-label">{{
          rewardMenuOptions[0].title
        }}</span>
      </button>
    </div>
    <div
      *ngIf="!reward?.hasExpired && !reward?.hasRedeemed"
      [matTooltip]="tooltip"
      [style.cursor]="canManageCustomer ? 'pointer' : 'not-allowed'"
    >
      <button
        [disabled]="!canManageCustomer"
        class="menu-list-item"
        style="border-radius: 5px"
        (click)="onClick(rewardMenuOptions[1].title, reward._id)"
        mat-menu-item
      >
        <mat-icon
          fontSet="material-icons-outlined"
          style="
            font-size: 16px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            margin-right: 5px;
          "
          >{{ rewardMenuOptions[1].icon }}</mat-icon
        >
        <span class="menu-list-item-label">{{
          rewardMenuOptions[1].title
        }}</span>
      </button>
    </div>
    <div
      *ngIf="!reward?.hasExpired && !reward?.hasRedeemed"
      [matTooltip]="tooltip"
      [style.cursor]="canManageCustomer ? 'pointer' : 'not-allowed'"
    >
      <button
        [disabled]="!canManageCustomer"
        class="menu-list-item"
        style="border-radius: 5px"
        (click)="onClick(rewardMenuOptions[2].title, reward._id)"
        mat-menu-item
      >
        <mat-icon
          fontSet="material-icons-outlined"
          style="
            font-size: 16px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            margin-right: 5px;
          "
          >{{ rewardMenuOptions[2].icon }}</mat-icon
        >
        <span class="menu-list-item-label">{{
          rewardMenuOptions[2].title
        }}</span>
      </button>
    </div>
  </ng-template>
</mat-menu>
